import AppHeader from "@/components/AppHeader";
import AppFooter from "@/components/AppFooter";
import { COMPANY_INFO } from "@/lib/companyInfo";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <AppHeader />
      <main className="container max-w-3xl py-16 px-4">
        <h1 className="font-heading text-3xl font-bold mb-2">Politica de Confidențialitate</h1>
        <p className="text-sm text-muted-foreground mb-8">
          Versiunea 2.0 · În vigoare de la: 17 aprilie 2026
        </p>
        <div className="prose prose-invert max-w-none space-y-6 text-muted-foreground text-sm leading-relaxed">

          <section className="rounded-lg border border-border bg-muted/30 p-4">
            <h2 className="font-heading text-base font-semibold text-foreground mb-2">Operator de date</h2>
            <p>
              <strong className="text-foreground">{COMPANY_INFO.legalName}</strong><br />
              Sediu social: <strong className="text-foreground">{COMPANY_INFO.registeredAddress}</strong><br />
              CUI: <strong className="text-foreground">{COMPANY_INFO.taxId}</strong> · Nr. Reg. Com.: <strong className="text-foreground">{COMPANY_INFO.registrationNumber}</strong><br />
              E-mail (responsabil cu protecția datelor): <a href={`mailto:${COMPANY_INFO.contactEmail}`} className="text-primary hover:underline">{COMPANY_INFO.contactEmail}</a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">1. Introducere</h2>
            <p>EZ Factura SRL respectă confidențialitatea datelor dumneavoastră. Această politică explică ce date colectăm, cum le folosim, cu cine le partajăm și ce drepturi aveți, în conformitate cu Regulamentul (UE) 2016/679 (GDPR) și Legea 190/2018.</p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">2. Date Colectate</h2>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong className="text-foreground">Date de identificare:</strong> nume, adresă de e-mail, parolă (hash)</li>
              <li><strong className="text-foreground">Date ale firmei:</strong> denumire, CUI, adresă sediu social, oraș, județ</li>
              <li><strong className="text-foreground">Date de facturare:</strong> informații despre facturi emise, clienți, furnizori, sume</li>
              <li><strong className="text-foreground">Date de plată:</strong> procesate direct de Stripe; nu stocăm date complete de card</li>
              <li><strong className="text-foreground">Date tehnice:</strong> adresă IP, tip browser, sistem de operare, loguri de acces și utilizare</li>
              <li><strong className="text-foreground">Documente încărcate:</strong> facturi în PDF/imagine pe care le scanați pentru extragere automată</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">3. Scopul Prelucrării</h2>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Furnizarea, întreținerea și îmbunătățirea Serviciului</li>
              <li>Generarea și trimiterea facturilor electronice către ANAF</li>
              <li>Gestionarea contului, abonamentului și plăților</li>
              <li>Comunicări legate de Serviciu (notificări, actualizări termeni, alertă securitate)</li>
              <li>Comunicări de marketing — doar cu consimțământul dumneavoastră, cu opțiune de dezabonare în orice moment</li>
              <li>Respectarea obligațiilor legale (raportare fiscală, arhivare)</li>
              <li>Prevenirea fraudei și securitatea platformei</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">4. Temeiul Legal</h2>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong className="text-foreground">Executarea contractului</strong> (Art. 6(1)(b) GDPR) — pentru furnizarea Serviciului</li>
              <li><strong className="text-foreground">Obligație legală</strong> (Art. 6(1)(c)) — pentru arhivare fiscală, raportare</li>
              <li><strong className="text-foreground">Interes legitim</strong> (Art. 6(1)(f)) — pentru securitate, prevenirea fraudei, îmbunătățirea Serviciului</li>
              <li><strong className="text-foreground">Consimțământ</strong> (Art. 6(1)(a)) — pentru marketing și cookie-uri non-esențiale</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">5. Sub-procesatori și Partajare</h2>
            <p>Nu vindem datele dumneavoastră. Le partajăm doar cu următorii sub-procesatori, sub contracte care le obligă la confidențialitate și conformitate GDPR:</p>
            <div className="rounded-lg border border-primary/30 bg-primary/5 p-3 mt-3 text-xs">
              <strong className="text-foreground">Trimitere către contabilul desemnat:</strong> dacă activați funcția „Trimite la contabil", transmitem facturile dumneavoastră (PDF + XML) către adresa de email pe care ați configurat-o, sub formă de arhivă ZIP cu link de descărcare valabil <strong className="text-foreground">30 de zile</strong>. Această prelucrare are loc <strong className="text-foreground">numai cu consimțământul dumneavoastră explicit</strong> (Art. 6(1)(a) GDPR), dat la prima utilizare a funcției. Consimțământul poate fi retras oricând din pagina Setări sau scriindu-ne la {COMPANY_INFO.contactEmail}. Sunteți responsabil pentru corectitudinea adresei contabilului.
            </div>
            <div className="overflow-x-auto mt-3">
              <table className="w-full text-xs border border-border">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="border border-border px-2 py-2 text-left text-foreground">Furnizor</th>
                    <th className="border border-border px-2 py-2 text-left text-foreground">Scop</th>
                    <th className="border border-border px-2 py-2 text-left text-foreground">Locație</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-border px-2 py-2">Supabase (Lovable Cloud)</td>
                    <td className="border border-border px-2 py-2">Bază de date, autentificare, stocare</td>
                    <td className="border border-border px-2 py-2">UE / SUA*</td>
                  </tr>
                  <tr>
                    <td className="border border-border px-2 py-2">Resend</td>
                    <td className="border border-border px-2 py-2">Trimitere emailuri tranzacționale</td>
                    <td className="border border-border px-2 py-2">SUA*</td>
                  </tr>
                  <tr>
                    <td className="border border-border px-2 py-2">Stripe</td>
                    <td className="border border-border px-2 py-2">Procesare plăți</td>
                    <td className="border border-border px-2 py-2">UE / SUA*</td>
                  </tr>
                  <tr>
                    <td className="border border-border px-2 py-2">Google AI (Gemini) / OpenAI</td>
                    <td className="border border-border px-2 py-2">Extragere date din facturi încărcate</td>
                    <td className="border border-border px-2 py-2">SUA*</td>
                  </tr>
                  <tr>
                    <td className="border border-border px-2 py-2">ANAF</td>
                    <td className="border border-border px-2 py-2">Validare CUI, trimitere e-Factura prin SPV</td>
                    <td className="border border-border px-2 py-2">România</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-3 text-xs">* <strong className="text-foreground">Transferuri internaționale:</strong> Pentru transferurile către SUA, ne bazăm pe (i) Clauzele Contractuale Standard (SCC) aprobate de Comisia Europeană și/sau (ii) certificarea furnizorilor în cadrul EU-US Data Privacy Framework, pentru a asigura un nivel adecvat de protecție.</p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">6. Securitatea Datelor</h2>
            <p>Implementăm măsuri tehnice și organizatorice rezonabile, inclusiv: criptare în tranzit (TLS), criptare la stocare, autentificare securizată cu hashing al parolelor, control de acces bazat pe rol, izolare la nivel de rând (Row-Level Security), monitorizare loguri și backup-uri periodice.</p>
            <p className="mt-2">Cu toate acestea, niciun sistem electronic nu este 100% securizat. Sub rezerva drepturilor imperative ale consumatorilor, nu putem garanta securitatea absolută și nu ne asumăm responsabilitatea pentru incidente cauzate de factori în afara controlului nostru rezonabil (atacuri cibernetice avansate, vulnerabilități terțe nedezvăluite, neglijența utilizatorului în păstrarea credențialelor).</p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">7. Notificare Încălcare Securitate (Data Breach)</h2>
            <p>În cazul unei încălcări a securității datelor cu caracter personal care prezintă risc pentru drepturile și libertățile dumneavoastră, vom:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Notifica Autoritatea Națională de Supraveghere (ANSPDCP) în maxim <strong className="text-foreground">72 de ore</strong> de la luarea la cunoștință (conform Art. 33 GDPR);</li>
              <li>Notifica utilizatorii afectați fără întârziere nejustificată, dacă riscul este ridicat (Art. 34 GDPR);</li>
              <li>Comunica natura incidentului, datele afectate, măsurile luate și recomandările pentru reducerea impactului.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">8. Limitarea Răspunderii privind Datele</h2>
            <p>Sub rezerva drepturilor imperative ale consumatorilor și a obligațiilor GDPR:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Nu suntem responsabili pentru compromiterea credențialelor dumneavoastră (parole reutilizate, dispozitive infectate, etc.)</li>
              <li>Sunteți responsabil pentru menținerea unor parole puternice și unice</li>
              <li>Vă recomandăm să nu stocați date sensibile suplimentare (date bancare, CNP-uri ale terților fără temei) în câmpurile libere ale platformei</li>
              <li>Răspunderea noastră totală este limitată conform Secțiunii 10 din <a href="/terms" className="text-primary hover:underline">Termeni și Condiții</a></li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">9. Durata Stocării</h2>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong className="text-foreground">Cont activ:</strong> pe toată durata utilizării Serviciului</li>
              <li><strong className="text-foreground">Loguri tehnice (email, token-uri dezabonare, suprimări):</strong> maxim <strong className="text-foreground">12 luni</strong>, apoi șterse automat</li>
              <li><strong className="text-foreground">Ștergere cont:</strong> după solicitare, datele (facturi, profil, setări) sunt păstrate <strong className="text-foreground">30 de zile</strong> pentru anulare; apoi șterse definitiv</li>
              <li><strong className="text-foreground">Documente fiscale:</strong> facturile pot fi arhivate până la <strong className="text-foreground">5 ani</strong> de la emitere, conform Codului Fiscal român</li>
              <li><strong className="text-foreground">Date de plată / facturare proprie:</strong> 10 ani conform Codului Fiscal</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">10. Drepturile Dumneavoastră (GDPR)</h2>
            <p>Aveți dreptul la:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong className="text-foreground">Acces</strong> — să primiți o copie a datelor pe care le deținem despre dumneavoastră</li>
              <li><strong className="text-foreground">Rectificare</strong> — să corectați datele incorecte</li>
              <li><strong className="text-foreground">Ștergere</strong> („dreptul de a fi uitat")</li>
              <li><strong className="text-foreground">Restricționarea prelucrării</strong></li>
              <li><strong className="text-foreground">Portabilitate</strong> — să primiți datele într-un format structurat</li>
              <li><strong className="text-foreground">Opoziție</strong> la prelucrarea bazată pe interes legitim sau marketing</li>
              <li><strong className="text-foreground">Retragerea consimțământului</strong> oricând (fără efect retroactiv)</li>
              <li><strong className="text-foreground">A nu face obiectul unei decizii automate</strong> (a se vedea Secțiunea 12)</li>
            </ul>
            <p className="mt-2">Cele mai multe drepturi pot fi exercitate direct din <a href="/settings" className="text-primary hover:underline">Setări</a>. Pentru restul, scrieți la <a href="mailto:contact@ezfactura.ro" className="text-primary hover:underline">contact@ezfactura.ro</a>. Vom răspunde în maxim 30 de zile.</p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">11. Cookie-uri</h2>
            <p>Folosim cookie-uri și tehnologii similare. Categoriile principale:</p>
            <div className="overflow-x-auto mt-3">
              <table className="w-full text-xs border border-border">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="border border-border px-2 py-2 text-left text-foreground">Categorie</th>
                    <th className="border border-border px-2 py-2 text-left text-foreground">Scop</th>
                    <th className="border border-border px-2 py-2 text-left text-foreground">Durată</th>
                    <th className="border border-border px-2 py-2 text-left text-foreground">Consimțământ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-border px-2 py-2">Esențiale (sesiune, autentificare)</td>
                    <td className="border border-border px-2 py-2">Funcționarea aplicației</td>
                    <td className="border border-border px-2 py-2">Sesiune – 1 an</td>
                    <td className="border border-border px-2 py-2">Nu este necesar</td>
                  </tr>
                  <tr>
                    <td className="border border-border px-2 py-2">Preferințe (temă, limbă)</td>
                    <td className="border border-border px-2 py-2">Memorarea opțiunilor</td>
                    <td className="border border-border px-2 py-2">1 an</td>
                    <td className="border border-border px-2 py-2">Implicit</td>
                  </tr>
                  <tr>
                    <td className="border border-border px-2 py-2">Analitice (dacă activate)</td>
                    <td className="border border-border px-2 py-2">Statistici de utilizare anonimizate</td>
                    <td className="border border-border px-2 py-2">Până la 2 ani</td>
                    <td className="border border-border px-2 py-2">Necesită consimțământ</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-2">Puteți gestiona preferințele din bannerul de cookie-uri afișat la prima vizită sau din setările browserului.</p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">12. Decizii Automate și Inteligență Artificială</h2>
            <p>Funcția de scanare a facturilor folosește modele AI (Google Gemini, OpenAI) pentru a extrage date din documentele încărcate. Aceasta este o procesare automată, dar:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Nu luăm decizii cu efect juridic semnificativ asupra dumneavoastră bazate exclusiv pe AI;</li>
              <li>Datele extrase sunt prezentate spre verificare și editare înainte de orice acțiune (creare factură, trimitere ANAF);</li>
              <li>Datele trimise către modelele AI sunt procesate strict în scopul extragerii și nu sunt folosite pentru antrenarea modelelor publice de către furnizori.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">13. Modificări ale Politicii</h2>
            <p>Putem actualiza această politică. Modificările substanțiale vor fi comunicate prin e-mail și/sau notificare în aplicație cu cel puțin 15 zile înainte de intrarea în vigoare. Versiunea curentă este afișată întotdeauna pe această pagină, cu data ultimei actualizări.</p>
          </section>

          <section>
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3">14. Contact și Reclamații</h2>
            <p>Pentru orice întrebare sau exercitarea drepturilor:<br />
              <strong className="text-foreground">{COMPANY_INFO.legalName}</strong><br />
              E-mail: <a href={`mailto:${COMPANY_INFO.contactEmail}`} className="text-primary hover:underline">{COMPANY_INFO.contactEmail}</a>
            </p>
            <p className="mt-2">Aveți dreptul de a depune o plângere la <strong className="text-foreground">Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</strong>:<br />
              B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, București<br />
              Web: <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.dataprotection.ro</a>
            </p>
          </section>
        </div>
      </main>
      <AppFooter />
    </div>
  );
};

export default Privacy;
